import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { KinshipResult } from '../types/api';

export const useKinship = (idA: string | null, idB: string | null) => {
    return useQuery({
        queryKey: ['kinship', idA, idB],
        queryFn: async () => {
            if (!idA || !idB) return null;

            const { data } = await apiClient.post<KinshipResult>('/kinship', { idA, idB });
            return data;
        },
        enabled: !!idA && !!idB,
    });
};
